import * as _ from 'underscore';
import { GrantLicenseModes, SyncActiveDirectoryGroupRequest } from '../../../ts/ServerApi/requests/SyncActiveDirectoryGroupRequest';
import { IActiveDirectoryGroup, SyncActiveDirectoryGroupsRequest } from '../../../ts/ServerApi/requests/SyncActiveDirectoryGroupsRequest';
import { IGroupBasicInfo } from '../../../ts/models/IGroupInfo';
import { IResult } from '../../../ts/ServerApi/types/IResponse';
import { SearchActiveDirectoryGroupNameRequest } from '../../../ts/ServerApi/requests/SearchActiveDirectoryGroupNameRequest';
import { ErrorNotifyingServer } from '../../../ts/services/ErrorNotifyingServer';
import { ServiceLocator } from '../../../app/ServiceLocator';
import { toNativePromise } from '../../../commonInfra/utils/QUtils';

const basicGroupInfoToAdGroup = (group: IGroupBasicInfo): IActiveDirectoryGroup => {
  return {
    name: group.name,
    domainName: group.domainName
  };
};

export namespace ActiveDirectoryGroups {

    // search for active directory groups
    export function searchActiveDirectoryGroupName(searchInputText: string): Promise<any> {
        const ErrorNotifyingServer = ServiceLocator.get<ErrorNotifyingServer>('ErrorNotifyingServer');
        const request = new SearchActiveDirectoryGroupNameRequest({name: searchInputText});
        return toNativePromise(ErrorNotifyingServer.sendRequest(request));
    }

    // synchronize a group, if the group does not exist then it will be added
    export function syncAdGroup(groupName: string, groupDomainName: string, siteRole?: string, grantLicenseMode?: GrantLicenseModes): Promise<any> {
        const ErrorNotifyingServer = ServiceLocator.get<ErrorNotifyingServer>('ErrorNotifyingServer');
        const request = new SyncActiveDirectoryGroupRequest({
            name: groupName,
            domainName: groupDomainName,
            siteRole: siteRole,
            grantLicenseMode: grantLicenseMode
        });
        return toNativePromise(ErrorNotifyingServer.sendRequest(request));
    }

    // synchronize groups
    export function syncAdGroups(groups: IGroupBasicInfo[]): Promise<IResult> {
        const ErrorNotifyingServer = ServiceLocator.get<ErrorNotifyingServer>('ErrorNotifyingServer');
        const adGroups = _.map(groups, basicGroupInfoToAdGroup);
        const request = new SyncActiveDirectoryGroupsRequest(adGroups);
        return toNativePromise(ErrorNotifyingServer.sendRequest(request));
    }

}

export type ActiveDirectoryGroups = typeof ActiveDirectoryGroups;
